module.exports = __webpack_public_path__ + "media/images/flags/4x3/tun-8ab7256aac5c8e7d77a58b3fb1a5f1e7.svg";